import React, { useState } from "react";
import { colors, spacing, typography } from "../../utils/designTokens";
import { FaArrowLeft } from "react-icons/fa";
import ContactoDesarrolladora from "../../components/ContactoDesarrolladora";
import { input, backBtn, Label, topbarStyle } from "./materialesUi";

// Tipo de material: primer contacto con una desarrolladora desde Materiales
// (sin ficha). El comercial escribe el nombre del estudio y arma el mensaje
// (WhatsApp o mail) con su firma + el folleto para adjuntar, listo para copiar/abrir.
export const TIPO_CONTACTO_DEV = "contacto_desarrolladoras";

export default function MaterialContactoDev({ material, isMobile, onClose }) {
  const [nombre, setNombre] = useState("");
  const [tel, setTel] = useState("");
  const [email, setEmail] = useState("");

  return (
    <div style={{ display: "flex", flexDirection: "column", height: "100%", minHeight: 0 }}>
      <div style={topbarStyle}>
        <button onClick={onClose} style={backBtn} aria-label="Volver a materiales">
          <FaArrowLeft size={12} /> {isMobile ? "" : "Materiales"}
        </button>
        <span style={{ fontSize: typography.sizes.lg, color: colors.gray900 }}>
          {material.nombre || "Primer contacto — Desarrolladoras"}
        </span>
      </div>

      <div style={{ padding: isMobile ? 16 : spacing[6], maxWidth: 660, margin: "0 auto", width: "100%", boxSizing: "border-box", overflowY: "auto" }}>
        <p style={{ fontSize: typography.sizes.sm, color: colors.gray600, marginTop: 0, lineHeight: 1.5 }}>
          Escribí el nombre del estudio/desarrolladora y armá el mensaje —WhatsApp o mail— con tu firma
          y el folleto para adjuntar. Después copiás y lo mandás, o lo abrís directo.
        </p>

        <div style={{ display: "grid", gap: spacing[3], marginBottom: spacing[4] }}>
          <div>
            <Label>Desarrolladora / estudio *</Label>
            <input
              value={nombre}
              onChange={(e) => setNombre(e.target.value)}
              placeholder="Ej. Aneff-Dibueno-Perelló / Arquitectos"
              style={input}
            />
          </div>
          <div style={{ display: "flex", gap: spacing[2], flexWrap: "wrap" }}>
            <div style={{ flex: "1 1 180px" }}>
              <Label>Teléfono (opcional)</Label>
              <input value={tel} onChange={(e) => setTel(e.target.value)} placeholder="Para abrir WhatsApp" style={input} />
            </div>
            <div style={{ flex: "1 1 180px" }}>
              <Label>Email (opcional)</Label>
              <input value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Para abrir el mail" style={input} />
            </div>
          </div>
        </div>

        <ContactoDesarrolladora dev={{ nombre, contactoTel: tel, contactoEmail: email }} />
      </div>
    </div>
  );
}
